import React from "react";
import { motion } from "framer-motion"; // Import Framer Motion for animations
import { FaChalkboardTeacher, FaSchool, FaUserGraduate, FaBusAlt, FaUtensils, FaLaptopCode } from "react-icons/fa"; // Import additional icons from react-icons
import CountUp from "react-countup"; // Import CountUp for counting effect
import { useInView } from "react-intersection-observer";

const Features = () => {
  const { ref, inView } = useInView({ triggerOnce: false, threshold: 0.2 });

  return (
    <motion.section
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 1 }}
      className="bg-white py-12 px-6 md:px-16"
      ref={ref}
    >
      <div className="text-center mb-8">
        <h2 className="text-3xl md:text-4xl font-bold text-blue-900 mb-4">
          Why Choose Joy Gardens School?
        </h2>
        <p className="text-gray-700 md:text-lg">
          We provide an exceptional learning environment for holistic development.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
        {/* Feature 1 */}
        <motion.div
          className="p-6 bg-gray-100 rounded-lg shadow-lg"
          whileHover={{ scale: 1.05 }}
        >
          <div className="text-center mb-4">
            <FaSchool className="text-blue-900 text-4xl mx-auto" />
          </div>
          <h3 className="text-xl font-bold text-blue-900 mb-2">Modern Facilities</h3>
          <p className="text-gray-600">
            State-of-the-art classrooms, labs, and boarding facilities compliant with current standards.
          </p>
        </motion.div>

        {/* Feature 2 */}
        <motion.div
          className="p-6 bg-gray-100 rounded-lg shadow-lg"
          whileHover={{ scale: 1.05 }}
        >
          <div className="text-center mb-4">
            <FaChalkboardTeacher className="text-blue-900 text-4xl mx-auto" />
          </div>
          <h3 className="text-xl font-bold text-blue-900 mb-2">Trained Experts</h3>
          <p className="text-gray-600">
            Supported by eminent scholars and experts in various learning areas.
          </p>
        </motion.div>

        {/* Feature 3 */}
        <motion.div
          className="p-6 bg-gray-100 rounded-lg shadow-lg"
          whileHover={{ scale: 1.05 }}
        >
          <div className="text-center mb-4">
            <FaUserGraduate className="text-blue-900 text-4xl mx-auto" />
          </div>
          <h3 className="text-xl font-bold text-blue-900 mb-2">Holistic Development</h3>
          <p className="text-gray-600">
            Focusing on academics, extracurriculars, and character building.
          </p>
        </motion.div>

        {/* Feature 4 */}
        <motion.div
          className="p-6 bg-gray-100 rounded-lg shadow-lg"
          whileHover={{ scale: 1.05 }}
        >
          <div className="text-center mb-4">
            <FaLaptopCode className="text-blue-900 text-4xl mx-auto" />
          </div>
          <h3 className="text-xl font-bold text-blue-900 mb-2">ICT Lessons</h3>
          <p className="text-gray-600">
            Fully equipped ICT classes with digital learning tools.
          </p>
        </motion.div>

        {/* Feature 5 */}
        <motion.div
          className="p-6 bg-gray-100 rounded-lg shadow-lg"
          whileHover={{ scale: 1.05 }}
        >
          <div className="text-center mb-4">
            <FaBusAlt className="text-blue-900 text-4xl mx-auto" />
          </div>
          <h3 className="text-xl font-bold text-blue-900 mb-2">Transport</h3>
          <p className="text-gray-600">
            An efficient fleet of buses covering all surrounding areas.
          </p>
        </motion.div>

        {/* Feature 6 */}
        <motion.div
          className="p-6 bg-gray-100 rounded-lg shadow-lg"
          whileHover={{ scale: 1.05 }}
        >
          <div className="text-center mb-4">
            <FaUtensils className="text-blue-900 text-4xl mx-auto" />
          </div>
          <h3 className="text-xl font-bold text-blue-900 mb-2">Meals</h3>
          <p className="text-gray-600">
            Balanced diet meals appropriate for every growth stage.
          </p>
        </motion.div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-12">
        {/* Stat 1 */}
        <motion.div
          className="text-center"
          initial={{ opacity: 0 }}
          animate={inView ? { opacity: 1 } : {}}
          transition={{ duration: 1 }}
        >
          <h3 className="text-4xl font-bold text-blue-900 mb-2">
            <CountUp start={inView ? 0 : null} end={900} duration={3} /> +
          </h3>
          <p className="text-gray-600">Enrolled Students</p>
        </motion.div>

        {/* Stat 2 */}
        <motion.div
          className="text-center"
          initial={{ opacity: 0 }}
          animate={inView ? { opacity: 1 } : {}}
          transition={{ duration: 1, delay: 0.2 }}
        >
          <h3 className="text-4xl font-bold text-blue-900 mb-2">
            <CountUp start={inView ? 0 : null} end={70} duration={3} /> +
          </h3>
          <p className="text-gray-600">Qualified Staff</p>
        </motion.div>

        {/* Stat 3 */}
        <motion.div
          className="text-center"
          initial={{ opacity: 0 }}
          animate={inView ? { opacity: 1 } : {}}
          transition={{ duration: 1, delay: 0.4 }}
        >
          <h3 className="text-4xl font-bold text-blue-900 mb-2">
            <CountUp start={inView ? 0 : null} end={100} duration={3} /> +
          </h3>
          <p className="text-gray-600">Modern Classrooms</p>
        </motion.div>
      </div>
    </motion.section>
  );
};

export default Features;
